import React,{useState,useEffect,useContext} from 'react'
import contextServices from './contextServices';
import associateProfileServices from '../app/associate/profile/associateProfileServices';
import associatedClinicServices from '../app/associate/profile/associatedClinicServices';
import scheduleServices from '../app/associate/schedule/scheduleServices';
import clinicTeamServices from '../app/clinic/clinicTeamServices';


const AppDataContext = React.createContext();

export const useAppData = () => {
    return useContext(AppDataContext);
}

export const AppDataProvider = (props) =>{
    
    const [loading,setLoadingStatus] = useState(false)
    const [associateProfile,setAssociateProfile] = useState(null);
    const [associatedClinicList,setAssociatedClinicList] = useState(null);
    const [receivedJoinRequest,setReceivedJoinRequest] = useState(null);

    const [associateBusinessHours,setAssociateBusinessHours] = useState(null);

    const [defaultClinic,setDefaultClinic] = useState(null);

    const [masters,setMasters] = useState(null);

    const getAssociateProfile = () =>{
        associateProfileServices.getProfile().then(res=>{
            setAssociateProfile(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    const getAssociateClinicList = () =>{
        associatedClinicServices.getAssociatedClinic().then(res=>{
            setAssociatedClinicList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    const getReceivedJoinRequest = () =>{
        clinicTeamServices.receivedJoinRequest().then(res=>{
            setReceivedJoinRequest(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    const getAssociateBusinessHours = () =>{
        scheduleServices.getAssociateBusinessHours().then(res=>{
            setAssociateBusinessHours(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    const getMasterList = () => {
        contextServices.get(["business-type","gender","media-source","plan-type","review-status"]).then(res=>{
            setMasters(res);
        }).catch(error=>{
        })
    }
    const getMasterLabel = (type, id) => {
        try{
            let label = masters[type].find(m => m.value === id)
            return label.label;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }

    const getAppDataById = (dataArray,id) =>{
        try{
            let data =  dataArray?.find(d => d.id === id)
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        }
        
    }
    

    const value= {
        associateProfile,setAssociateProfile,getAssociateProfile,
        associatedClinicList,setAssociatedClinicList,getAssociateClinicList,
        receivedJoinRequest,getReceivedJoinRequest,
        associateBusinessHours,getAssociateBusinessHours,
        
        defaultClinic,setDefaultClinic,
        masters,getMasterLabel,
        getAppDataById,
        loading
    }

    useEffect(()=>{
        getAssociateProfile();
        getAssociateClinicList();
        getReceivedJoinRequest();
        getAssociateBusinessHours();
        getMasterList();
    },[])
    
    return <AppDataContext.Provider value= {value}>{props.children}</AppDataContext.Provider>
}